import { useEffect, useState } from "react";
import {
  PayPalScriptProvider,
  PayPalButtons,
  usePayPalScriptReducer
} from "@paypal/react-paypal-js";

const style = { layout: "horizontal", color: "blue", shape: "rect", label: "pay", tagline: false }

const ButtonWrapper = ({ currency, showSpinner, amount, confirmHandler, disabled, dataForPaypalButton }) => {
  const [{ options, isPending }, dispatch] = usePayPalScriptReducer();

  useEffect(() => {
    dispatch({
      type: "resetOptions",
      value: {
        ...options,
        currency: currency,
      },
    });
  }, [currency, showSpinner]);

  // Funzione che effettua il pagamento tramite paypal della submission list inviata a AiGrading
  const createOrder = (data, actions) => {
    return actions.order.create({
      intent: "capture",
      purchase_units: [
        {
          amount: {
            value: amount,
          },
        },
      ],
    });
  }


  // Funzione che gestisce l'avvenuto pagamento tramite paypal della submission list inviata a AiGrading
  const onApprove = (data, actions) => {
    return actions.order.capture().then(function(details) {
      confirmHandler(details.id)
    });
  }



  return (<React.Fragment>
      { (showSpinner && isPending) && <div className="spinner" /> }
      <PayPalButtons
        style={style}
        disabled={disabled}
        forceReRender={[amount, currency, style, dataForPaypalButton]}
        fundingSource={undefined}
        createOrder={(data, actions) => createOrder(data, actions) }
        onApprove={(data, actions) => onApprove(data, actions)}
      />
    </React.Fragment>
  );
}

const PaypalButton = ({
    amount,
    confirmHandler,
    disabled,
    paypalClientId,
    locale,
    dataForPaypalButton
  }) => {

  // Impostazioni Paypal per effettuare il pagamento all'aggregator al momento
  // della conferma finale da parte dell'utente della submission list
  const payPalOptions = {
    "client-id": paypalClientId,
    currency: "EUR",
    components: "buttons",
    intent: "capture",
    locale: locale === 'it' ? 'it_IT' : 'en_US'
  };

  return (
    <div className="minW-350px"
         id="paypal-button">
      <PayPalScriptProvider options={payPalOptions}>
        <ButtonWrapper
          currency={payPalOptions.currency}
          showSpinner={false}
          amount={amount}
          confirmHandler={confirmHandler}
          disabled={disabled}
          dataForPaypalButton={dataForPaypalButton}
        />
      </PayPalScriptProvider>
    </div>
  );
}


export default PaypalButton;